<template lang="pug">
	.drag-list-control
		draggable.drag-list(:disabled="!isUsedItemsDraggable" :list="usedItemsList" dragClass="draggable-list-chosen" animation="200" draggable=".draggable-list" filter=".item-image" @start="onStart('used')" @end="onEnd" ghost-class="ghost" :group="'drag-list-' + this._uid")
			div.draggable-list(v-for="element in usedItemsList" :key="element.id")
				.item-name {{ element.name }}
				.item-image(v-if="modals[element.id] && modals[element.id].url" @click="modalToggle(element.id)")
					i.icon-picture
					.item-image-modal(v-if="activeModal === element.id" :style="{backgroundImage: `url(${modals[element.id].url})`, width: modals[element.id].size[0] + 'px', height: modals[element.id].size[1] + 'px'}")
			.drag-list-header(slot="header" role="group") {{checkCustomData(0)}}
		draggable.drag-list(:list="unusedItemsList" dragClass="draggable-list-chosen" animation="200" draggable=".draggable-list" filter=".item-image" @start="onStart('unused')" @end="onEnd" ghost-class="ghost" :group="'drag-list-' + this._uid")
			div.draggable-list(v-for="element in unusedItemsList" :key="element.id")
				.item-name {{ element.name }}
				.item-image(v-if="modals[element.id] && modals[element.id].url" @click="modalToggle(element.id)")
					i.icon-picture
					.item-image-modal(v-if="activeModal === element.id" :style="{backgroundImage: `url(${modals[element.id].url})`, width: modals[element.id].size[0] + 'px', height: modals[element.id].size[1] + 'px'}")
			.drag-list-header(slot="header" role="group") {{checkCustomData(1)}}

</template>

<script>

	import draggable			from "vuedraggable";

	import Screen 				from './../../../mixins/screen';
	import { Creative } 			from './../../../services/Creative';
	import { Settings } 		from './../../../services/Settings';
	import { Asset } 			from './../../../services/Asset';

	import SetupSettings		from "./../../../settings/settings";

	export default {
		name: "DoubleDragListControl",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Switched", "Selected Version Fully Loaded"]
		},
		props: ['setting', 'id'],
		components: {
			draggable
		},
		data() {

			this.values = [];

			return {
				showed: true,
				isUnusedDragActive: false,
				usedItemsList: [],
				unusedItemsList: [],
				modals: [],
				activeModal: null
			}
		},
		computed: {
			isUsedItemsDraggable() {

				return this.isUnusedDragActive ||
					(typeof this.setting.options.minItemsCount === 'number' && this.usedItemsList.length > this.setting.options.minItemsCount);

			}
		},
		mounted() {

			//Сообщаем компоненту что он должен обновляться при изменении текущей настройки активной версии креатива
			this.addUpdateEvent(`Selected Version Setting Changed:${this.setting.codename}`);

		},
		methods: {
			collectData() {

				if (!Version.SelectedVersion || !this.setting || !Settings.isSettingExist(this.setting.codename)) return console.log('DoubleDragListControl collectData FAILED', this.setting?.['codename'], Version.SelectedVersion?.id, this.setting?.['version_id']);

                const usedItems = (typeof this.id === 'number') ? Settings.getSettingValue(this.setting.codename)[this.id] : Settings.getSettingValue(this.setting.codename);

				if (!Array.isArray(usedItems) || !Creative.SelectedCreative || !Version.SelectedVersion) return;

				this.values = (typeof this.id === 'number') ? this.setting.options.values[this.id].map((item, id) => _.assign({id}, item)) : this.setting.options.values.map((item, id) => _.assign({id}, item));

				this.values.forEach(value => {

					if (!value.image) return;

					if (!Asset.getAsset(Version.SelectedVersion, value.image.name)) return;

					this.modals[value.id] = {
						url: `${location.protocol}//${SetupSettings["domain"]}/deploy/${Creative.SelectedCreative.codename}/${Asset.getAsset(Version.SelectedVersion, value.image.name).url}`,
						size: Array.isArray(value.image.size) ? value.image.size.slice() : [200, 200]
					};

				});

                if (typeof this.id === 'number') {
                    this.unusedItemsList = usedItems.map(id => this.values[id]);
                    this.usedItemsList = this.values.filter((item, id) => (usedItems.indexOf(id) === -1) && item);
                } else {
                    this.usedItemsList = usedItems.map(id => this.values[id]);
                    this.unusedItemsList = this.values.filter((item, id) => (usedItems.indexOf(id) === -1) && item);
                }

			},
			onStart(type) {

				this.activeModal = null;

				const types = {
					'used': () => {},
					'unused': () => {

						this.isUnusedDragActive = true;

					}
				};

				if (types[type]) types[type]();

			},
			onEnd() {

				this.isUnusedDragActive = false;

                if (typeof this.id === 'number') {

                    let settingValueToSet = Settings.getSettingValue(this.setting.codename);
                    settingValueToSet[this.id] = this.unusedItemsList.map(item => item.id)
                    Settings.setSettingValue(this.setting.codename, settingValueToSet);

                } else {
                    Settings.setSettingValue(this.setting.codename, this.usedItemsList.map(item => item.id));
                }

			},
			isEnabled(list, minCount) {

				return list.length > minCount;

			},
			modalToggle(id) {

				if (this.activeModal === id) this.activeModal = null;
				else this.activeModal = id;

			},
            checkCustomData(id) {

			    if (this.setting.options.customData && this.setting.options.customData.columnNames && this.setting.options.customData.columnNames[id]) {
			        return this.setting.options.customData.columnNames[id];
                } else if (id === 0) {
                    return 'Used items';
                } else if (id === 1) {
                    return 'Unused items';
                }

            }
		}
	}
</script>

<style lang="sass">

	.drag-list-control
		display: flex
		justify-content: space-between
		user-select: none
		position: relative

		.draggable-list-chosen
			display: flex
			justify-content: space-between
			background-color: #283036
			border: 1px solid #23282c
			border-radius: 3px
			cursor: grabbing

		.ghost
			background-color: #283036
			border: none
			border-bottom: 1px solid #23282c
			border-radius: 0

		.drag-list
			height: 170px
			width: 49%
			background-color: #343b41
			border: 1px solid #23282c
			border-radius: 3px
			overflow-x: hidden
			overflow-y: auto

			.drag-list-header
				text-align: center
				background-color: #343b41
				padding: 2px 5px
				border-bottom: 1px solid #23282c

			.draggable-list
				padding: 2px 5px
				border-bottom: 1px solid #23282c
				cursor: grab
				display: flex
				justify-content: space-between

				.item-image
					cursor: pointer
					transition: 0.2s

					&:hover
						color: #20a8d8

					.item-image-modal
						top: 5px
						left: 5px
						position: absolute
						border-radius: 3px
						background-color: #343b41
						border: 1px solid #23282c
						background-size: 96% auto
						background-repeat: no-repeat
						background-position: center center
						box-shadow: 0 0 5px 1px #0f0f0f
						z-index: 100

</style>
